import { gql } from "@apollo/client/core";

/**
 * GraphQL Queries for Authentication
 */

/**
 * Get Salesforce OAuth authorization URL
 */
export const GET_AUTHORIZATION_URL = gql`
  query GetAuthorizationUrl($environment: String!) {
    authorizationUrl(environment: $environment) {
      url
      state
    }
  }
`;

/**
 * Generate JWT token from secret key
 */
export const GENERATE_JWT = gql`
  mutation GenerateJwt($input: GenerateJwtInput!) {
    generateJwt(input: $input) {
      user {
        id
        email
      }
      organisations {
        id
        orgName
        orgType
        instanceUrl
        metadataTypeCounts {
          count
          metadataType
        }
      }
      jwtToken
    }
  }
`;

/**
 * Force-refresh the caller's Salesforce OAuth access token. Used by the
 * "Reconnect Salesforce" pill in the chat header. Org is inferred from
 * the JWT — no arguments. Errors come back as GraphQL errors with a
 * `message` like "Failed to refresh token: :no_token" or
 * "No organizations found for user".
 */
export const REFRESH_SALESFORCE_TOKEN = gql`
  mutation RefreshSalesforceToken {
    refreshSalesforceToken {
      success
    }
  }
`;

